export default {
  emptylist: {
    text: {
      notes: 'Text on actions to take to add entity (equipment, company etc)',
      message: 'Click the add button above to add the first {{type}}',
    },
  },
};
